module.exports = __webpack_public_path__ + "img/needle.071340f8.png";